const triggerPostToVerifyBetaAccess = async ( username ) => {
    try {
      // Send POST request to the list charges in Stripe
      const response = await fetch('https://api.gotcowjuice.com:2000/verify-beta-access', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'cow-juice-api-key': process.env.REACT_APP_COWJUICE_API_KEY,
        },
        body: JSON.stringify({ username }),
      });
          
      // Check if the response is ok
      if (!response.ok) {
        throw new Error('Failed to verify beta access');
      }
  
      // Parse the JSON response from the server
      const res = await response.json();
      
      return res.success === true; // Return true if access is granted, false otherwise

    } catch (error) {
      // Log any errors and return null in case of failure
      console.error("Error verifying beta access:", error);
      return null;
    }
  };
  
  export default triggerPostToVerifyBetaAccess;  